module.exports = __webpack_public_path__ + "static/img/nodata.33eea074.png";